// API Configuration
const getApiUrl = () => {
  const fallback =
    process.env.NODE_ENV === 'production'
      ? 'https://kanang-alalay-backend.onrender.com/api'
      : 'http://localhost:5000/api';
  const raw = process.env.REACT_APP_API_URL || fallback;
  const trimmed = raw.replace(/\/+$/, '');
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
};

export const API_URL = getApiUrl();
console.log('🔧 API URL:', API_URL);

// Helper function for fetch requests
// credentials: 'include' tells the browser to send the httpOnly cookie automatically
export const apiFetch = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;

  const defaultOptions = {
    credentials: 'include',           // sends ka_token cookie on every request
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, mergedOptions);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'API request failed');
    }

    return data;
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    throw error;
  }
};
